import { Metadata } from '@cedarjs/web'

import HeadingLevel from 'src/components/Custom/Heading/Heading'

import ResourceLinksSection from './ResourceLinksSection'
import SystemMessagesSection from './SystemMessagesSection'

const SystemMessagingPage = () => {
  return (
    <div className="flex min-h-screen w-full bg-gray-50">
      <Metadata title="System Messaging" />
      <div className="mx-8 flex flex-grow flex-col py-6 text-gray-900">
        <HeadingLevel level={1}>System Messaging</HeadingLevel>
        <SystemMessagesSection />
        <ResourceLinksSection />
      </div>
    </div>
  )
}
export default SystemMessagingPage
